<script setup>
import {defineProps} from "vue";
import CommentSmall from "@/views/projects/pdf/comments/CommentSmall.vue";

const props = defineProps({
  comments: Array[Object]
})

function addComment() {
  const commentArea = document.getElementById("comment_area")
  const children = commentArea.children
  const lastElement = children[children.length - 1]
  props.comments.push({
    text: "",
    top: lastElement.offsetTop + lastElement.offsetHeight + 20,
    height: 50,
    style: {
      fontSize: 10,
      bold: false,
      color: "#000000",
    }
  })
}

function removeComment(index) {
  props.comments.splice(index, 1);
}
</script>

<template>
  <div class="comment-area" id="comment_area">
    <button class="btn btn-sm btn-outline-dark" @click="addComment">+</button>
    <template v-for="(comment, index) in comments">
      <comment-small :comment="comment" :index="index" :remove-comment="removeComment"></comment-small>
    </template>

  </div>
</template>

<style scoped lang="scss">
.comment-area {
  position: relative;
  width: 100%;
  height: 100%;
  background: #fff;
}

</style>